module.exports = __webpack_public_path__ + "static/media/noun-question-670406-656565.fcb5ff56.svg";